import * as Yup from "yup";

export const OnboardingValidation = Yup.object({
    // onboardingItemMetumId: Yup.number()("Item is required!"),
    onboardingItemMetumName: Yup.string().required("Item is required!"),
    onboardingItemStatusId: Yup.number().required("Status is required!"),
    tier: Yup.string().required("Tier is required!"),
})